module.exports = __webpack_public_path__ + "img/lasource-19.d5970417.jpg";